export const OTP_TEST_IDS = {
  mandatory2faNotice: 'auth-otp-setup-mandatory-2fa-notice',
  setupCopyKeyButton: 'auth-otp-setup-copy-key-button',
  setupEnableButton: 'auth-otp-setup-enable-button',
  setupSecretKeyValue: 'auth-otp-setup-secret-key-value',
  setupShowKeyButton: 'auth-otp-setup-show-key-button',
  verificationCodeNotWorkingButton: 'auth-otp-code-not-working-button',
  verificationNextButton: 'auth-otp-next-button',
} as const;
